module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/internals/is-pure.js
// module id = 706
// module chunks = 25